import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-wheelchair-ranking-classif',
  templateUrl: './wheelchair-ranking-classif.component.html',
  styleUrls: ['./wheelchair-ranking-classif.component.scss']
})

export class WheelchairRankingClassifComponent implements OnInit {
  /**
   * Definição para receber o identificador do ranking
   */
  rankingId: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
      this.rankingId = this.route.snapshot.paramMap.get('rankingId');
  }
}
